module.exports = __webpack_public_path__ + "img/CS2_section_4_speech_bubble-01.95020ed6.png";